import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useClientAuth} from '../contexts/ClientAuthContext';
import {
    PUBLIC_CLIENT_ROUTES,
    ROUTES
} from '../constants/PathRoutes';
import Loading from "./admin/Loading";

export default function ProtectedClientRoute({children}) {
    const {isAuthenticated, loading, user} = useClientAuth();
    const location = useLocation();

    if (loading) {
        return (
            <Loading minHeight={'100vh'}/>
        );
    }

    const isPublicRoute = Object.values(PUBLIC_CLIENT_ROUTES).includes(location.pathname);


    // Se nao esta autenticado e nao e rota publica, redireciona para login
    if (!isAuthenticated() && !isPublicRoute) {
        return <Navigate to={ROUTES.AREA_ASSOCIADO_LOGIN} replace/>;
    }

    // Se esta autenticado, verifica se o email esta verificado
    if (isAuthenticated()) {
        const isEmailVerificationRoute = location.pathname === ROUTES.AREA_ASSOCIADO_VERIFICAR_EMAIL;
        const emailVerified = user?.profile?.email_verified;

        // Se email nao esta verificado e nao esta na pagina de verificacao, redireciona
        if (!emailVerified && !isEmailVerificationRoute) {
            return <Navigate to={ROUTES.AREA_ASSOCIADO_VERIFICAR_EMAIL} replace/>;
        }

        // Se email esta verificado e esta na pagina de verificacao, redireciona para home
        if (emailVerified && isEmailVerificationRoute) {
            return <Navigate to={ROUTES.LOJA_HOME} replace/>;
        }
    }

    return children;
}